import { render, staticRenderFns } from "./problemDetailList.vue?vue&type=template&id=db31a540&scoped=true"
import script from "./problemDetailList.vue?vue&type=script&lang=js"
export * from "./problemDetailList.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/qualityStyle.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./problemDetailList.vue?vue&type=style&index=1&id=db31a540&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db31a540",
  null
  
)

export default component.exports